import _ from 'lodash';
import MainWorker from '../webworkers/main.worker.js';
import {openDB, deleteDB, wrap, unwrap} from 'idb';
import stringHash from 'string-hash';
import syncConfig from '../offline/sync.config.js';

// This middleware updates offline_db by removing all the records that have been successfullly synced.
const syncUpdate = (config) => (store) => (next) => (action) => {
	if (!(action.meta && action.meta.sync)) {
		return next(action);
	}

	const ONLINE_DB = 'ONLINE_DB',
		OFFLINE_DB = 'OFFLINE_DB';

	const dbPromise = openDB('canvas-idb', 1, {
		upgrade(db) {
			db.createObjectStore(ONLINE_DB);
			db.createObjectStore(OFFLINE_DB);
		}
	});

	const idbKeyval = {
		async get(key) {
			return (await dbPromise).get(ONLINE_DB, key);
		},
		async getOffline(key) {
			return (await dbPromise).get(OFFLINE_DB, key);
		},
		async getAllOffline() {
			return (await dbPromise).getAll(OFFLINE_DB);
		},
		async set(key, val) {
			return (await dbPromise).put(ONLINE_DB, val, key);
		},
		async setOffline(key, val) {
			return (await dbPromise).put(OFFLINE_DB, val, key);
		},
		async delete(key) {
			return (await dbPromise).delete(OFFLINE_DB, key);
		},
		async clear() {
			return (await dbPromise).clear(ONLINE_DB);
		},
		async keys() {
			return (await dbPromise).getAllKeys(ONLINE_DB);
		}
	};

	const appOnlineState = store.getState().apponlinestate;

	if (_.isBoolean(appOnlineState) && appOnlineState) {
		if (action.meta && action.meta.sync) {
			//Clean up OFFLINE_DB since the update is complete
			let _id, url;

			if (action.meta.api.method === 'POST' || action.meta.api.method === 'DELETE') {
				// To handle removefromtask and approaval as we are maininting hash value based on method without id
				switch (action.type) {
					case 'ASSOCIATE_TASK_DOCUMENTS':
						if (action.meta.api.method === 'DELETE') {
							url = action.meta.api.url.split('/' + action.meta.api.data.DocumentId)[0];
						} else {
							url = action.meta.api.url + '_' + (action.meta.api.data.TaskId || action.meta.api.data.taskIds[0]);
						}
						break;
					case 'REMOVE_APPROVAL_FOR_DOCUMENT':
						url = action.meta.api.url.split('/' + action.meta.api.data.approvalId)[0];
						break;
					default:
						url = action.meta.api.url;
						break;
				}
				url = url.toLowerCase() + action.meta.api.method;
				_id = stringHash(url);
			} else if (action.meta.api.method === 'PATCH' || action.meta.api.method === 'PUT') {
				if (_.isArray(action?.meta?.api?.data)) {
					url = action.meta.api.url.toLowerCase() + action.meta.api.method + action.meta.api.data[0].path;
					_id = stringHash(url);
				} else {
					let offlineRecords = syncConfig[action.type];
					if (offlineRecords && offlineRecords.length > 0) {
						let patchConfig = offlineRecords.filter((x) => x.updateEntity === Object.keys(action.meta.api.data)[0]);
						let updateEntity = patchConfig[0] ? patchConfig[0].updateEntity : '';

						_id = stringHash(action.meta.api.url.toLowerCase() + action.meta.api.method + updateEntity);
					} else {
						_id = stringHash(action.meta.api.url.toLowerCase() + action.meta.api.method);
					}
				}
			}

			console.log('_id and url', `_id - ${_id}, URL - ${url}`);

			// get the record from offlineDB using the hash
			idbKeyval.getOffline(_id).then((d) => {
				if (d) {
					sessionStorage.setItem('syncItems', parseInt(sessionStorage.getItem('syncItems')) - 1);

					if (parseInt(sessionStorage.getItem('syncItems')) === 0) {
						next({
							type: 'SET_SYNC_STATE',
							syncState: false
						});
						idbKeyval.delete('sync_keys');
					}
					idbKeyval.delete(_id);

					//action.response[item.updateEntity] = d.meta.api.data[0].value;
					// idbKeyval.delete(_id).then((s) => {
					// 	console.log(
					// 		'Successfully remove the Offline changes in IDB after sync'
					// 	);
					// idbKeyval.getAllOffline().then((keys) => {
					// 	if (keys.length == 0) {
					// 		next({
					// 			type: 'SET_SYNC_STATE',
					// 			syncState: false
					// 		});
					// 	}
					// });
					// });
				}
				return next(action);
			});
		}
	}

	return next(action);
};

export default syncUpdate;
